import { render, staticRenderFns } from "./WorkAssessment.vue?vue&type=template&id=553b2378&scoped=true&"
import script from "./WorkAssessment.vue?vue&type=script&lang=js&"
export * from "./WorkAssessment.vue?vue&type=script&lang=js&"
import style0 from "./WorkAssessment.vue?vue&type=style&index=0&id=553b2378&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b2378",
  null
  
)

export default component.exports